module.exports = __webpack_public_path__ + "img/zh2.81247090.png";